export default __webpack_public_path__ + "static/media/how-electricity-gets-to-your-house-image.f7a4e42b.jpg";